import { render, staticRenderFns } from "./prayerTime.vue?vue&type=template&id=5052a28d&scoped=true"
import script from "./prayerTime.vue?vue&type=script&lang=js"
export * from "./prayerTime.vue?vue&type=script&lang=js"
import style0 from "./prayerTime.vue?vue&type=style&index=0&id=5052a28d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5052a28d",
  null
  
)

export default component.exports